<template>
    <div>
        <div v-if="user">
            <EvaluationComponent></EvaluationComponent>
        </div>
        <div class="my-2" v-else>
            <div class="mb-2 d-flex" v-if="training">
                <div class="mx-2">
                    <img
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8Fb0JfnooRfkiWm-ZNiYcNVs0_pnHZCfdFqaDuaq2swumeP49LZdT4I0fovUIq7CbM0k&usqp=CAU"
                        class="training-img"
                    />
                </div>
                <div>
                    <p class="employee-title">{{ training }}</p>
                    <p class="my-0 fade-text">{{ userList.userWorksheetSummaryList.length }} Enrolled</p>
                </div>
            </div>

            <!-- <hr> -->
            <hr v-if="training" class="my-1 mb-3" />
            <!-- {{userList.userWorksheetSummaryList}} -->
            <div class="employee-card" v-for="(employee, index) in userList.userWorksheetSummaryList" :key="index" >
                <!-- {{employee}}
            <hr> -->
                <div class="d-flex align-items-start justify-content-between">
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <img
                                class="profile-img"
                                :src="employee.profileImg"
                                v-if="employee.profileImg"
                                alt="employee image"
                            />
                            <img
                                class="profile-img"
                                v-else
                                :src="`https://avatars.dicebear.com/api/initials/${employee.name}.svg`"
                                alt="employee image"
                            />
                        </div>
                        <div class="ms-2">
                            <div class="d-flex align-items-center">
                                <p class="employee-title">{{ employee.name }}</p>
                            </div>
                            <p class="employee-subtitle">{{ employee.emailId }}</p>
                            <!-- <p class="employee-subtitle">{{ structureDesignation(employee.designation) }}</p> -->
                        </div>
                    </div>
                    <div v-if="!employee.evaluated">
                        <Button label="Evaluate" class="qb-btn qb-btn-black-sm" @onClick="evaluate(employee)"></Button>
                    </div>
                    <div v-else>
                        <Button
                            label="View Report"
                            class="qb-btn qb-btn-outline-sm"
                            @onClick="viewscores(employee)"
                        ></Button>
                    </div>
                </div>
            </div>
            <div v-if="userList.userWorksheetSummaryList.length==0" class="d-flex justify-content-center">
                <div class="info d-flex gap-3 p-3 mt-2 mb-0 align-items-center justify-content-center">
                    <div><font-awesome-icon icon="fa-solid fa-circle-exclamation" /></div>
                    <p class="my-0 fade-text">No Users Enrolled</p>
                </div>
            </div>
        </div>
        <Modal @close="toggleEvaluationScoreModal" :modalActive="showEvaluationScoreModal">
            <div>
                <div class="d-flex gap-2">
                    <div>
                        <img
                            class="profile-img"
                            :src="evaluationEmployee.profileImg"
                            v-if="evaluationEmployee.profileImg"
                            alt="employee image"
                        />
                        <img
                            class="profile-img"
                            v-else
                            :src="`https://avatars.dicebear.com/api/initials/${evaluationEmployee.name}.svg`"
                            alt="employee image"
                        />
                    </div>
                    <div class="ms-2">
                        <div class="d-flex align-items-center">
                            <p class="employee-title">{{ evaluationEmployee.name }}</p>
                        </div>
                        <p class="employee-subtitle">{{ evaluationEmployee.emailId }}</p>
                        <!-- <p class="employee-subtitle">{{ structureDesignation(employee.designation) }}</p> -->
                    </div>
                </div>
                <hr />
            </div>
            <div class="d-flex justify-content-between info-box p-3">
                <div class="">
                    <p class="head-title">Evaluation Template Used</p>
                    <p class="head-subtitle">{{ evaluationScore.templateModelName }}</p>
                </div>
                <div class="">
                    <p class="head-title">Evaluation Done By</p>
                    <p class="head-subtitle">{{ evaluationScore.addedByName }}</p>
                </div>
            </div>

            <div class="mt-3">
                <table class="table">
                    <thead>
                        <tr>
                            <th class="small">Evaluation Field</th>
                            <th class="small">Score</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(data, index) in evaluationScore.score" :key="index">
                            <td>{{ index }}</td>
                            <td>{{ data }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="my-2">
                <p class="my-0 head-title">Comments :</p>
                <p class="my-0 reporter-title">{{ evaluationScore.comment }}</p>
            </div>
            <hr />
            <Button label="Download Report" @onClick="download()" class="qb-btn qb-btn-black-md" />
        </Modal>
        <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="false"
            filename="Evaluation Report"
            :paginate-elements-by-height="1100"
            :pdf-quality="2"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="800px"
            :manual-pagination="false"
            @hasDownloaded="hasDownloaded($event)"
            ref="html2Pdf"
        >
            <section slot="pdf-content">
                <div class="d-flex justify-content-center ">
                <div class="template-box p-3 ">
                 <div>
                <div class="d-flex gap-2">
                    <div>
                        <img
                            class="profile-img"
                            :src="evaluationEmployee.profileImg"
                            v-if="evaluationEmployee.profileImg"
                            alt="employee image"
                        />
                        <img
                            class="profile-img"
                            v-else
                            :src="`https://avatars.dicebear.com/api/initials/${evaluationEmployee.name}.svg`"
                            alt="employee image"
                        />
                    </div>
                    <div class="ms-2">
                        <div class="d-flex align-items-center">
                            <p class="employee-title">{{ evaluationEmployee.name }}</p>
                        </div>
                        <p class="employee-subtitle">{{ evaluationEmployee.emailId }}</p>
                        <!-- <p class="employee-subtitle">{{ structureDesignation(employee.designation) }}</p> -->
                    </div>
                </div>
                <hr />
            </div>
            <div class="d-flex justify-content-between info-box p-3">
                <div class="">
                    <p class="head-title">Evaluation Template Used</p>
                    <p class="head-subtitle">{{ evaluationScore.templateModelName }}</p>
                </div>
                <div class="">
                    <p class="head-title">Evaluation Done By</p>
                    <p class="head-subtitle">{{ evaluationScore.addedByName }}</p>
                </div>
            </div>

            <div class="mt-3">
                <table class="table">
                    <thead>
                        <tr>
                            <th class="small">Evaluation Field</th>
                            <th class="small">Score</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(data, index) in evaluationScore.score" :key="index">
                            <td>{{ index }}</td>
                            <td>{{ data }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="my-2">
                <p class="my-0 head-title">Comments :</p>
                <p class="my-0 reporter-title">{{ evaluationScore.comment }}</p>
            </div>
                </div>
                </div>
            </section>
        </vue-html2pdf>
    </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';
import Button from '../components/ButtonComponent.vue';
import EvaluationComponent from '../components/EvaluationComponent.vue';
const { mapGetters: authMapGetters } = createNamespacedHelpers('Auth');
import Modal from '../components/ModalComponent.vue';
// import Card from "../components/CardComponent.vue"
import { createNamespacedHelpers } from 'vuex';
const { mapGetters: trainingMapGetters, mapActions: trainingMapActions } = createNamespacedHelpers('Training');

export default {
    name: 'UserList',
    data() {
        return {
            showEvaluationScoreModal: false,
            evaluationEmployee: {},
        };
    },
    methods: {
        ...trainingMapActions({
            getUsersForEnrolledTraining: 'GET_USERS_FOR_ENROLLED_TRAINING',
            getUserEvaluation: 'SET_USER_IN_EVALUATION',
            getEvaluationTraining: 'SET_TRAINING_FOR_EVALUATION',
            getEvaluationScore: 'GET_EVALUATION_SCORE',
        }),

        evaluate(user) {
            let payload = user;
            this.getUserEvaluation({ payload });
            this.getTaskScoreForUser({
                payload: { userId: user.id, trainingId: this.$route.paramas.trainingId },
                // adminId: this.loggedInUser.userId,
            });
        },
        structureDesignation(designation) {
            return designation.split('_').join(' ');
        },
        viewscores(employee) {
            this.getEvaluationScore({
                payload: {
                    userId: employee.id,
                    trainingId: this.$route.params.trainingId,
                },
                adminId: this.loggedInUser.userId,
            });
            this.evaluationEmployee = employee;
            this.toggleEvaluationScoreModal();
        },
        toggleEvaluationScoreModal() {
            this.showEvaluationScoreModal = !this.showEvaluationScoreModal;
        },
         generateReport () {
            this.$refs.html2Pdf.generatePdf()
            
        },
        download(){
            this.generateReport()
        }
    },
    computed: {
        ...trainingMapGetters({
            userList: 'getSelectedTrainingForUserSummary',
            user: 'getUserInEvaluation',
            training: 'getTrainingForEvaluation',
            evaluationScore: 'getEvaluationScore',
        }),
        ...authMapGetters({
            loggedInUser: 'getUser',
        }),
    },
    components: {
        // Card,
        EvaluationComponent,
        Button,
        Modal,
        VueHtml2pdf,
    },
    mounted() {
        this.getUsersForEnrolledTraining({ id: this.$router.params.trainingId });
    },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/color.scss';
@import '../assets/scss/font.scss';
@import '../assets/scss/field.scss';

.card-box {
    padding: 0px 10px 10px 10px;
    border-radius: $field-border-radius;
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    overflow-y: hidden;
    gap: 10px;
}
.card-box:hover {
    cursor: pointer;
}

.chart-area {
    width: 150px;
    height: 100px;
}

.reporter-label {
    font-size: $font-size-sm;
    color: $badger-orange;
    font-weight: $font-weight-bold;
    margin: 0px;
}

.reporter-title {
    font-size: $font-size-sm;
    color: $dark-200;
    font-weight: $font-weight-bold;
    margin: 0px;
}

.card-box::-webkit-scrollbar {
    background: none;
    height: 5px;
}

.card-box::-webkit-scrollbar-thumb {
    background-color: $border-color;
    border-radius: $field-border-radius;
}

.module-card {
    min-width: 300px;
}

.worksheet-title {
    font-weight: 600;
    font-size: 14px;
    margin: 0px;
    margin-bottom: 5px;
}

.profile-img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
}

.employee-card {
    background-color: $white;
    padding: 8px 12px;
    border-radius: $field-border-radius;
    margin-bottom: 10px;
    border: 1px solid $light-200;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;

    // &:hover {
    //   background-color: $light-fade-200;
    //   cursor: pointer;
    // }
}

.employee-title {
    font-size: $font-size-md;
    font-weight: $font-weight-normal-2;
    margin-bottom: 0px;
}

.employee-subtitle {
    font-size: $font-size-sm;
    color: $light-600;
    // font-weight: $font-weight-normal-1;
    margin-bottom: 0px;
    width: fit-content;
}

.task-count {
    min-width: fit-content;
}

.modal-heading {
    font-size: $font-size-xxl;
    font-weight: 600;
}
.sub-heading {
    font-size: $font-size-md;
    font-weight: 600;
}
.submission {
    border: 1px solid $light-200;
    border-radius: $field-border-radius;
}
.training-img {
    width: 60px;
    height: 35px;
    border-radius: 5px;
}
.fade-text {
    color: $light-500;
    font-size: $font-size-md;
    font-weight: $font-weight-normal-1;
    margin: 0px;
}
.head-title {
    color: $dark-400;
    font-size: $font-size-md;
    font-weight: $font-weight-bold;
    margin: 0px;
}
.head-subtitle {
    color: $dark-200;
    font-size: $font-size-sm;
    font-weight: $font-weight-normal-1;
    margin: 0px;
}
.info-box {
    background-color: #fff9e9;
    border-radius: 5px;
    width: 100%;
}
.template-box{
    width:500px;
}
.info {
    background-color: #fff9e9;
    border-radius: 5px;
    width:max-content
}
.fa-circle-exclamation {
    color: #fec12f;
}
</style>
